import {
  type PaidSpecContractType,
  type SpecContractType,
} from '../types/contract';

// DONT CHANGE ITEM ORDERS
const specContractList: Array<SpecContractType | PaidSpecContractType> = [
  'Custom',
  'Golden',
  'GoldenPlus',
  'Blitz',
  'BlitzPlus',
  'Grand',
  'GrandPlus',
];

const uniqueSpecContractList: Array<SpecContractType> = [
  'Custom',
  'Golden',
  'Blitz',
  'Grand',
];

const paidSpecContractList: Array<PaidSpecContractType> = [
  'GoldenPlus',
  'BlitzPlus',
  'GrandPlus',
];

const specContractModalsName = {
  Grand: 'grandContractModal',
  GrandPlus: 'grandContractModal',
  Blitz: 'blitzContractModal',
  BlitzPlus: 'blitzContractModal',
  Custom: 'customContractModal',
  Golden: 'goldenContractModal',
  GoldenPlus: 'goldenContractModal',
} as const;

// DONT CHANGE ITEM ORDERS
const nextSpecContractTimeFields = [
  'nextCustomContractTime',
  'nextGoldContractTime',
  'nextGoldContractTime',
  'nextBlitzContractTime',
  'nextBlitzContractTime',
  'nextGrandContractTime',
  'nextGrandContractTime',
] as const;

export {
  nextSpecContractTimeFields,
  paidSpecContractList,
  specContractList,
  specContractModalsName,
  uniqueSpecContractList,
};
